import { useRef } from "react";
import PlatformAdminHeader from "./components/PlatformAdminHeader";
import OperatingAoisPanel from "./OperatingAoisPanel";

export default function OperatingAOIsPage() {
  const panelRef = useRef(null);

  return (
    <div className="flex flex-col h-full">
      {/* HEADER */}
      <PlatformAdminHeader
        title="Operating AOIs"
        subtitle="Customer operating footprints"
        onAoiUploaded={(aoi) => {
          // Auto-select newly uploaded AOI
          panelRef.current?.reload(aoi?.id);
        }}
      />

      {/* BODY */}
      <div className="flex-1 min-h-0">
        <OperatingAoisPanel ref={panelRef} />
      </div>
    </div>
  );
}